export const getUserAgent = () => {
  return navigator.userAgent || navigator.vendor || window.opera;
};

export const getPlatform = () => {
  return navigator?.userAgentData?.platform || navigator?.platform || 'unknown';
};

export const isIOS = () => {
  const userAgent = getUserAgent();
  const platform = getPlatform();
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(platform) ||
    // iPad on iOS 13 detection
    (userAgent?.includes('Mac') && 'ontouchend' in document)
  );
};
export const isAndroid = () => {
  const userAgent = getUserAgent();
  return userAgent && /android/i.test(userAgent);
};
